import { DeleteTenantRequestSchema, DeleteTenantResponseSchema } from './delete-tenant.schema';
/**
 * Delete Tenant Endpoint Contract
 * Deletes a tenant (super-admin only)
 *
 * Refused while a clone job for this tenant is still `running`. Deletion
 * revokes the tenant's memberships and then soft-deletes the row, and a
 * detached clone that is still provisioning would re-create those memberships
 * immediately afterwards, leaving global registry state pointing at a deleted
 * tenant. Deleting is not a way to cancel a clone: park it, then discard it via
 * `POST /api/v2/tenant-clone-jobs/:jobId/discard`.
 */ export const deleteTenantContract = {
    method: 'DELETE',
    path: '/api/v2/tenants/:tenantId',
    description: 'Delete a tenant',
    requestSchema: DeleteTenantRequestSchema,
    responseSchema: DeleteTenantResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Tenant not found',
            409: 'A clone job for this tenant is still running - a detached clone would re-provision the memberships the deletion just revoked'
        }
    }
};

//# sourceMappingURL=delete-tenant.contract.js.map